// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "facturaDetail" + "." + "aea1c6ec" + ".chunk.css";
};